<template>
	<b-modal id="vitals-adjuster" title="Adjust Vitals" v-model="show" @shown="shown" size="sm" body-class="text-center" hide-footer>
		<div class="row mb-3">
			<div class="col">
				<input ref="input" type="number" class="form-control mb-2" value="0" v-model.number="Input" id="vitals-input">
				<div class="button-group w-100 d-flex justify-content-between">
					<b-button variant="danger" @click="takeDamage()">Damage</b-button>
					<b-button variant="primary" @click="resetDamage()">Reset</b-button>
					<b-button variant="success" @click="healDamage()">Healing</b-button>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="button-group w-100 d-flex justify-content-between">
					<b-button v-b-toggle.tempHP variant="default" onClick="this.firstChild.classList.toggle('fa-rotate-90')"><font-awesome-icon icon="chevron-right"></font-awesome-icon> Temporary HP</b-button>
					<b-button variant="primary" @click="refreshTempHP()"><font-awesome-icon icon="redo" /> Round</b-button>
				</div>
			</div>
		</div>
		<b-collapse id="tempHP">
			<div class="card card-body">
				<div class="form-group">
					<label>Maximum Temp HP</label>
					<input type="number" class="form-control" v-model.number="TemporaryHitPoints.Max">
				</div>
				<div class="form-group">
					<label>Fast Healing</label>
					<input type="number" class="form-control" v-model.number="TemporaryHitPoints.Heal">
				</div>
				<div class="form-group">
					<label>Current Temp HP</label>
					<input type="number" class="form-control" v-model.number="TemporaryHitPoints.HP">
				</div>
				<div class="button-group w-100 d-flex justify-content-between mb-2">
					<button class="btn btn-danger" @click="deactivateTempHP()">Deactivate</button>
					<button class="btn btn-success" @click="activateTempHP()">Activate</button>
				</div>
			</div>
		</b-collapse>
	</b-modal>
</template>

<script>
export default {
	data: function() {
		return {
			Input: '',
		}
	},
	computed: {
		show: {
			get: function() {
				return this.$store.state.modals.vitals.show
			},
			set: function(value){
				this.$store.commit('modals/set','vitals',value)
			}
		},
		TemporaryHitPoints: function(){
            return this.$store.state.Character.Current.Points.Temporary
		},
		TempHitPointsMax: {
			get: function() {
				return this.$store.state.Character.Current.Points.Temporary.Max
			},
			set: function(value) {
				this.$store.commit('setCharacterProp',[
					{
						key: 'Current.Points.Max',
						val: value,
					}
				])
			}
		},
		TempHitPointsCurrent: {
			get: function() {
				return this.$store.state.Character.Current.Points.Temporary.HP
			},
			set: function(value) {
				this.$store.commit('setCharacterProp',[
					{
						key: 'Current.Points.HP',
						val: value,
					}
				])
			}
		},
		TempHitPointsHeal: {
			get: function() {
				return this.$store.state.Character.Current.Points.Temporary.Heal
			},
			set: function(value) {
				this.$store.commit('setCharacterProp',[
					{
						key: 'Current.Points.Heal',
						val: value,
					}
				])
			}
		},
        HitPointsMax: function(){
            return this.$store.state.hitPoints
        },
        HitPointsCurrent: function(){
            return this.$store.state.Character.Current.Points.Hit
        },
        StaminaPointsMax: function(){
            return this.$store.state.staminaPoints
        },
        StaminaPointsCurrent: function(){
            return this.$store.state.Character.Current.Points.Stamina
        },
        ResolvePointsMax: function(){
            return this.$store.state.resolvePoints
        },
        ResolvePointsCurrent: function(){
            return this.$store.state.Character.Current.Points.Resolve
        },
	},
	methods: {
		shown: function() {
			this.$refs.input.focus()
		},
		done: function() {
			this.Input = ''
			this.show = false
		},
		takeDamage: function() {
			this.$store.dispatch('character/status/takeDamage',this.Input)
			this.done()
		},
		healDamage: function() {
			this.$store.dispatch('character/status/healDamage',this.Input)
			this.done()
		},
		resetDamage: function() {
			this.$store.dispatch('character/status/reset')
			this.done()
		},
		refreshTempHP: function() {
			this.$store.dispatch('character/status/refreshTempHP')
			this.done()
		},
		activateTempHP: function() {
			this.$store.dispatch('character/status/activateTempHP')
			this.done()
		},
		deactivateTempHP: function() {
			this.$store.dispatch('character/status/deactivateTempHP')
			this.done()
		}
	}
}
</script>

<style scoped>

</style>